import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../PricingHub/SearchComponent';

class OrderDetailSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'date',
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'date',
    },
    {
      label: 'label.accountId',
      name: 'accountId',
    },
    {
      label: 'label.orderType',
      name: 'orderType',
      type: 'select',
      tOptions: 'selections:types',
      isClearable: true,
    },
    {
      label: 'label.accountType',
      name: 'accountType',
      type: 'select',
      tOptions: 'selections:accountType',
      isClearable: true,
    },
    {
      label: 'label.orderStatus',
      name: 'status',
      type: 'select',
      tOptions: 'selections:statusOrder',
      isClearable: true,
    },
    {
      label: 'label.organization',
      name: 'company',
    },
    { label: 'label.lineOfBusiness', name: 'lineOfBusiness' },
    {
      label: 'common:label.groupBy',
      name: 'groupBy',
      type: 'checkbox',
      // wrapperClass: 'form-group mt-4 pt-2 col-md-3',
      wrapperClass: 'form-group mt-4 col-md-3',
      tooltipDetails: 'common:message.groupByOrderReportInfo',
    },
  ];

  btnSpan = 'col-md-9';
}

OrderDetailSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

OrderDetailSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(OrderDetailSearchForm);
